<template lang="html">
  <div class="row">
    <div class="col-lg-3"></div>
    <div class="col-lg-9 pet-review-back">
      <PetReviewModal :petId='response.petId'/>
    </div>
  </div>
</template>

<script>
import PetReviewModal from '../../components/review/addReview.vue';
export default {
  data(){
    return {
      response: {
        petId: null
      }
    }
  },
  created(){
    this.$bus.$on('language', () => {
      this.translation = window.message;
    });
    this.$bus.$on('approvedPassport', () => {
      this.getPassport();
    });
    this.translation = window.message;
    if (localStorage.getItem('userLoggedIn') != undefined) {
      if ( localStorage.getItem('userLoggedIn') == true
        || localStorage.getItem('userLoggedIn') == 'true') {
          this.response.petId = this.$route.params.petId;
          this.getPet();
      }
    }else {
      this.$router.push('/')
    }

  },
  beforeRouteUpdate ( to, from , next ) {
    this.response.petId = to.params.petId;
    this.getPet();
    localStorage.setItem('petName', this.pet.petName );
    next()
  },
  components:{
    PetReviewModal
  },
  methods: {
    getPet: function(){
     this.loader = true;
     var formData = this.toFormData(this.response);
     var self = this;
     axios.post('view-pet-profile', formData)
     .then(function (response) {
       self.loader = false;
       if (response.data.result.noAccess) {
         self.$router.push({ name: 'home', params: { lang: window.lang } })
       }else {
         self.pet = response.data.result;
         localStorage.setItem('petName', self.pet.petName );
         self.getPassport();
         if (response.data.result.petReview) {
           self.pet.petReview = '../../..' + response.data.result.petReview;

         }
       }
     })
     .catch(function (error) {
       console.log(error);
     })
   },
   getPassport: function(){
      var formData = this.toFormData(this.response);
      var self = this;
      axios.post('get-pet-passport', formData)
      .then(function(response){
        self.passport = response.data.result;
      })
      .catch(err => err)
    },
    toFormData: function (obj){
      var form_data = new FormData();
      for (var key in obj) {
        form_data.append(key,obj[key]);
      }
      return form_data;
    },
  }
}
</script>

<style>
.pet-review-back {
  background-image: url('../../assets/img/backgrounds/background-after-login.jpg');
  background-repeat:no-repeat;
  max-width:inherit;
  max-height: 100%;
  background-position: center;
  background-size: cover;
  min-height:100vh;
}
</style>
